// Multi-language translations EN/AR
export const translations = {
  en: {
    appName: "Pharma CRM",
    appTagline: "Distribution Intelligence",
    // Auth
    login: "Login",
    logout: "Logout",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    role: "Role",
    signIn: "Sign In",
    signOut: "Sign Out",
    welcomeBack: "Welcome back",
    enterCredentials: "Enter your credentials to access the platform",
    // Nav
    dashboard: "Dashboard",
    doctors: "Doctors",
    pharmacies: "Pharmacies",
    products: "Products",
    visits: "Visits & Routes",
    orders: "Orders & Sales",
    collections: "Collections",
    inventory: "Inventory",
    marketIntel: "Market Intelligence",
    expenses: "Expenses",
    cashflow: "Cash Flow",
    performance: "Performance",
    users: "Team & Users",
    whatsapp: "WhatsApp Broadcast",
    mapView: "Map View",
    routePlanner: "Route Planner",
    auditLog: "Audit Log",
    settings: "Settings",
    customers: "Customers",
    quotations: "Quotations",
    invoices: "Tax Invoices",
    companySettings: "Company Settings",
    weeklyPlans: "Weekly Plans",
    planDashboard: "Plan Dashboard",
    // Common
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    search: "Search",
    filter: "Filter",
    export: "Export",
    excel: "Excel",
    pdf: "PDF",
    actions: "Actions",
    view: "View",
    close: "Close",
    submit: "Submit",
    loading: "Loading...",
    noData: "No data available",
    // Roles
    admin: "Admin",
    supervisor: "Supervisor",
    sales_rep: "Sales Rep",
    // KPIs
    dailySales: "Daily Sales",
    monthlySales: "Monthly Sales",
    dailyCollections: "Daily Collections",
    monthlyCollections: "Monthly Collections",
    outstanding: "Outstanding Balance",
    totalDoctors: "Doctors",
    totalPharmacies: "Pharmacies",
    totalProducts: "Products",
    totalReps: "Sales Reps",
    visits30: "Visits (30d)",
    orders30: "Orders (30d)",
    salesTrend: "Sales & Collections (14 days)",
    topPharmacies: "Top Pharmacies",
    topProducts: "Top Products",
    repPerformance: "Rep Performance",
    marketAlerts: "Recent Market Intelligence",
    salesByProduct: "Sales by Product (30d)",
    expiryAlerts: "Expiry Alerts",
    // Doctor fields
    fullName: "Full Name",
    specialty: "Specialty",
    governorate: "Governorate",
    city: "City",
    area: "Area",
    mobile: "Mobile",
    kolClass: "KOL Class",
    clinicName: "Clinic Name",
    // Pharmacy
    pharmacyName: "Pharmacy Name",
    branch: "Branch",
    owner: "Owner",
    classification: "Class",
    otcLevel: "OTC Movement",
    // Order
    invoice: "Invoice #",
    pharmacy: "Pharmacy",
    rep: "Rep",
    total: "Total",
    status: "Status",
    paymentStatus: "Payment",
    date: "Date",
    // Visit
    checkIn: "Check In",
    checkOut: "Check Out",
    notes: "Notes",
    // Money
    egp: "EGP",
    // Lang
    language: "Language",
    english: "English",
    arabic: "العربية",
  },
  ar: {
    appName: "فارما CRM",
    appTagline: "ذكاء التوزيع",
    login: "تسجيل الدخول",
    logout: "خروج",
    register: "تسجيل",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    role: "الدور",
    signIn: "دخول",
    signOut: "تسجيل الخروج",
    welcomeBack: "مرحبا بعودتك",
    enterCredentials: "أدخل بياناتك للدخول إلى المنصة",
    dashboard: "لوحة القيادة",
    doctors: "الأطباء",
    pharmacies: "الصيدليات",
    products: "المنتجات",
    visits: "الزيارات والمسارات",
    orders: "الطلبات والمبيعات",
    collections: "التحصيلات",
    inventory: "المخزون",
    marketIntel: "ذكاء السوق",
    expenses: "المصروفات",
    cashflow: "التدفق النقدي",
    performance: "الأداء",
    users: "الفريق والمستخدمون",
    whatsapp: "بث واتساب",
    mapView: "الخريطة",
    routePlanner: "خطة المسار",
    auditLog: "سجل النشاط",
    settings: "الإعدادات",
    customers: "العملاء",
    quotations: "عروض الأسعار",
    invoices: "الفواتير الضريبية",
    companySettings: "إعدادات الشركة",
    weeklyPlans: "الخطط الأسبوعية",
    planDashboard: "لوحة الخطط",
    add: "إضافة",
    edit: "تعديل",
    delete: "حذف",
    save: "حفظ",
    cancel: "إلغاء",
    search: "بحث",
    filter: "تصفية",
    export: "تصدير",
    excel: "إكسل",
    pdf: "PDF",
    actions: "إجراءات",
    view: "عرض",
    close: "إغلاق",
    submit: "إرسال",
    loading: "جاري التحميل...",
    noData: "لا توجد بيانات",
    admin: "مدير",
    supervisor: "مشرف",
    sales_rep: "مندوب",
    dailySales: "مبيعات اليوم",
    monthlySales: "مبيعات الشهر",
    dailyCollections: "تحصيلات اليوم",
    monthlyCollections: "تحصيلات الشهر",
    outstanding: "الرصيد المستحق",
    totalDoctors: "الأطباء",
    totalPharmacies: "الصيدليات",
    totalProducts: "المنتجات",
    totalReps: "المندوبون",
    visits30: "الزيارات (30 يوم)",
    orders30: "الطلبات (30 يوم)",
    salesTrend: "المبيعات والتحصيلات (14 يوم)",
    topPharmacies: "أفضل الصيدليات",
    topProducts: "أفضل المنتجات",
    repPerformance: "أداء المندوبين",
    marketAlerts: "ذكاء السوق الأخير",
    salesByProduct: "المبيعات حسب المنتج (30 يوم)",
    expiryAlerts: "تنبيهات انتهاء الصلاحية",
    fullName: "الاسم الكامل",
    specialty: "التخصص",
    governorate: "المحافظة",
    city: "المدينة",
    area: "المنطقة",
    mobile: "الموبايل",
    kolClass: "تصنيف KOL",
    clinicName: "اسم العيادة",
    pharmacyName: "اسم الصيدلية",
    branch: "الفرع",
    owner: "المالك",
    classification: "التصنيف",
    otcLevel: "حركة OTC",
    invoice: "رقم الفاتورة",
    pharmacy: "الصيدلية",
    rep: "المندوب",
    total: "الإجمالي",
    status: "الحالة",
    paymentStatus: "الدفع",
    date: "التاريخ",
    checkIn: "تسجيل وصول",
    checkOut: "تسجيل خروج",
    notes: "ملاحظات",
    egp: "ج.م",
    language: "اللغة",
    english: "English",
    arabic: "العربية",
  },
};

export function t(lang, key) {
  return (translations[lang] && translations[lang][key]) || translations.en[key] || key;
}
